<template>
  <Card class="mx-auto max-w-lg px-4 py-8 mt-28">
    <div class="mx-auto max-w-lg text-center">
      <h1 class="text-2xl font-bold sm:text-3xl">Sign in to Duna Labs!</h1>

      <p class="mt-4 text-gray-500">
        Some features require an account
      </p>
    </div>

    <p v-if="props.error" class="text-red-500">{{ props.error }}</p>

    <form class="mx-auto mb-0 mt-8 max-w-md space-y-4" @submit.prevent>
      <div>
        <label for="email" class="font-medium">Email</label>
        <div class="relative">
          <input type="email" v-model="state.email" placeholder="Enter email"/>
        </div>
      </div>

      <div>
        <label for="password" class="font-medium">Password</label>
        <div class="relative">
          <input type="password" v-model="state.password" placeholder="Enter password"/>
        </div>
      </div>

      <div v-show="state.mode === 'register'">
        <label for="confirmPassword" class="font-medium">Confirm Password</label>
        <div class="relative">
          <input type="password" min="12" v-model="state.confirmPassword" placeholder="Enter password"/>
        </div>
      </div>

      <div class="flex items-center justify-between">
        <button type="button" tabindex="-1" v-if="state.mode === 'login'" class="outline-primary" @click="switchMode('register')">Register</button>
        <button type="button" tabindex="-1" v-if="state.mode === 'register'" class="outline-primary" @click="switchMode('login')">Login</button>

        <button type="submit" @click="submit()">
          {{ state.mode === 'login' ? 'Sign in' : 'Create account' }}
        </button>
      </div>
    </form>
  </Card>

</template>

<script setup>
  import {reactive} from 'vue'
  import Card from '../components/Card.vue'
  import http from '../../helpers/http'
  import {basicHash} from '../../helpers/encryption'
  import { router } from '@inertiajs/vue3'

  const props = defineProps({
    error: String
  })


  let state = reactive({
    mode: "login", // or "register"
    email: "",
    password: "",
    confirmPassword: "",
  })
  function submit() {
    if (state.mode === 'login') {
      console.log('login')
      router.post('/login', {
        user: {
          email: state.email,
          password: basicHash(state.password),
          password_length: state.password.length
        }
      })
    } else if (state.mode === 'register') {
      if (state.password !== state.confirmPassword) {
        alert("Passwords do not match")
        return
      }
      if (state.password.length < 12) {
        alert("Password must be at least 12 characters")
        return
      }
      http.post('/register', {
        user: {
          email: state.email,
          password: basicHash(state.password),
          confirm_password: basicHash(state.confirmPassword),
          password_length: state.password.length
        }
      }).then((response) => {
        console.log(response)
      }).catch((error) => {
        console.log(error)
      })
    }

  }

  function switchMode(newMode) {
    console.log('switchMode')
    state.mode = newMode
  }

  function onEnter() {
    console.log('onEnter')
  }


</script>